import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ApplicationDto, RoleDto, UserDto } from '@clearing-hub/common';
import { UserService } from '../../../service/user.service';
import { Json } from '../../../model/Json';
import { UpdateUserRolesForm } from '../../../model/UpdateUserRolesForm';
import { UpdateUserRolesCommand } from '@clearing-hub/command';
import { AccordionComponent } from '../../accordion/accordion.component';

@Component({
  selector: 'fxch-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateUserComponent implements OnInit, OnDestroy {

  @ViewChild('accordionComponent') accordionComponent: AccordionComponent;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  userForm: FormGroup<UpdateUserRolesForm>;
  user: UserDto;
  userRoles: Array<RoleDto>;
  collapsing = false;
  applications: Array<ApplicationDto>;
  applicationsJson: Json<number, ApplicationDto>;
  // applicationsJson: any;
  applicationAccessesState: Json<number, boolean> = new Json<number, boolean>();
  isSubmitEnabled = true;

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly userService: UserService
              // private readonly userStore: Store<UserState>
  ) {
  }

  missingRoleForApplicationValidator() {
    return (form: FormGroup<UpdateUserRolesForm>): {[key: string]: boolean} | null => {
      for (const a of this.applications) {
        if (this.applicationAccessesState[a.id] && (this.userForm.controls.roles[a.id] === null || this.userForm.controls.roles[a.id] ===  undefined)) {
          return {
            missingRoleForApplication: false
          }
        }
      }
      return null;
    }
    //   const newPassword = form.value.newPassword;
    //   const newPasswordAgain = form.value.newPasswordAgain;
    //   if (newPassword !== newPasswordAgain) {
    //     return {
    //       passwordsMatched: false
    //     }
    //   }
    //   return null;
    // };
  }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      // id: new FormControl({disabled: true, value: this.user.id}),
      email: new FormControl({value: this.user.email, disabled: true}),
      // roles: this.getApplicationRoles()
      // roles: new FormControl(this.user.roles)
      roles: this.fb.group({
        ...this.getApplicationRoles()
      })
    }, [this.missingRoleForApplicationValidator]);

    this.applicationsJson = new Json<number, ApplicationDto>(this.applications, 'id');
    this.applications.forEach(a => {
      const appRole = this.userRoles.find(r => r.applicationId === a.id);
      if (appRole) {
        this.applicationAccessesState[a.id] = true;
      } else {
        this.applicationAccessesState[a.id] = false;
      }
    });

    this.subscriptions.push(
      this.userForm.get('roles').valueChanges.subscribe((event) => {
        this.setIsSubmitEnabled(event);
      })
    );
  }

  getApplicationRoles(): Json<string, FormControl<string>> {
    const appRoles: Json<string, FormControl<string>> = new Json<number, FormControl<string>>();
    this.applications.forEach(a => {
      appRoles[a.id] = new FormControl<string>(this.userRoles.find(r => r.applicationId === a.id)?.name)
    })
    return appRoles;
  }

  update(): void {
    const command: UpdateUserRolesCommand = {
      id: this.user.id,
      email: this.user.email,
      roles: {}
    }
    Object.keys(this.userForm.value.roles).forEach(k => {
      const actualRole = this.userForm.value.roles[k];
      if (actualRole !== undefined && actualRole !== null) {
        command.roles[k] = this.userForm.value.roles[k];
      }
    });

    this.userService.updateUser(command).subscribe(() => {
      this.modalRef.hide();
    });
  }

  close(): void {
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  toggleApplication(event: boolean, index: number, applicationId: string) {
    if (!event) {
      const isExpanded = this.accordionComponent.expanded.has(index);
      if (isExpanded) {
        this.accordionComponent.toggleState(index, false);
      }
      this.userForm.controls.roles.controls[applicationId].setValue(null);
    } else {
      this.accordionComponent.toggleState(index);
    }
    this.setIsSubmitEnabled();
  }

  setIsSubmitEnabled(formValue = this.userForm.value.roles) {
    this.isSubmitEnabled = Object.keys(formValue).every(a => !this.applicationAccessesState[a] || formValue[a] !== null && this.applicationAccessesState[a]);
  }
}
